
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" allowClear  placeholder="搜索关键字"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="赛季赛区">
              <a-cascader @change="onSjsqChange" :show-search="{ sjsqFilter }" :options="sjsqOptions" :fieldNames="{ label: 'name', value: 'id', children: 'children' }" placeholder="请选择赛区" v-model="queryParam.sjsq" changeOnSelect
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="项目">
              <a-cascader :options="subjectOptions" :fieldNames="{ label: 'name', value: 'key', children: 'children' }" placeholder="请选择项目" v-model="queryParam.subjects" changeOnSelect 
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="状态">
              <a-select v-model="queryParam.memberstatus" placeholder="请选择"
                        allowClear >
                <a-select-option value="1">秩序册</a-select-option>
                <a-select-option value="2">项目填写</a-select-option>
                <a-select-option value="3">人员统计</a-select-option>
                <a-select-option value="4">住宿信息</a-select-option>
                <a-select-option value="5">等待付款</a-select-option>
                <a-select-option value="6">报名成功</a-select-option>
                <a-select-option value="-1">弃权</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="授权编号">
                <a-input v-model="queryParam.kaojiregist_code" placeholder="搜索授权编号"/>
              </a-form-item>
            </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="单位名称">
              <a-input v-model="queryParam.danwei" placeholder="搜索单位名称"/>
            </a-form-item>
          </a-col>


          <a-col :md="6" :sm="24">
            <a-form-item label="考试时间">
              <a-range-picker
                      v-model="time_range_moment"
                      style="width: 100%"
                      format="YYYY-MM-DD HH:mm:ss"
                      :showTime="{
                defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                }"
              />
            </a-form-item>
          </a-col>

           </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px" v-if="false">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator" >

      <a-button @click="download(1)" style="margin-left: 8px"  >
        参赛项目汇总表 <a-icon type="download" />
      </a-button>

      <a-button @click="download(2)" style="margin-left: 8px"  >
        参赛队伍所报项目汇总表 <a-icon type="download" />
      </a-button>

      <a-button @click="download(3)" style="margin-left: 8px"  >
        运动员参赛项目信息表 <a-icon type="download" />
      </a-button>

    </div>
    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >

      <span slot="danwei" slot-scope="text,record">
          <div style="margin-left: 10px; float: left">
            {{record.subject_name}}
            <br/><span style="color: #999">{{record.mingcheng}}</span>
            <br/>
            {{record.create_time|timeFormat}}
          </div>
      </span>
      <span slot="saiqu" slot-scope="text,record">
        {{record.saiqu_name}}
      </span>
      <span slot="status" slot-scope="text,record">
        <a-tag v-if="record.memberstatus==1" >秩序册</a-tag>
        <a-tag v-if="record.memberstatus==2" >项目填写</a-tag>
        <a-tag v-if="record.memberstatus==3" >人员统计</a-tag>
        <a-tag v-if="record.memberstatus==4" >住宿信息</a-tag>
        <a-tag color="purple" v-if="record.memberstatus==-1">弃权</a-tag>
        <a-tag v-if="record.memberstatus==5" color="red">等待付款</a-tag>
        <a-tag v-else-if="record.memberstatus==6" color="green">报名成功</a-tag>
      </span>
      <span slot="action" slot-scope="text,record">
        <template >
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm title="删除后不可恢复,确定删除吗?" @confirm="onDelete(record)"  okText="确定" cancelText="取消">
            <a href="javascript:;">删除</a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>



    <a-modal
        :maskClosable="false"
            title="操作"
            :width="1200"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="visible"
            @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form" >
          <a-row :gutter="48">
            <a-col :md="48" :sm="48">
          <a-form-item
                  :labelCol="{
                    xs: { span: 12 },
                    sm: { span: 4 },}"
                  :wrapperCol="{
                    xs: { span: 12 },
                    sm: { span: 20 }}"
                  label="项目名称"
                  hasFeedback
            >
            <!--{{formData.subject_name}}-->


            <a-cascader :options="formData.subject_options" :fieldNames="{ label: 'name', value: 'key', children: 'children' }" placeholder="请选择项目" v-model="formData.subjects"    @change="onFormSubjectChange"
            />
          </a-form-item>
              </a-col>
            </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="运动员"
                  hasFeedback
          >
            <div v-for="(user,index) in formData.yundongyuan" :key="index" >
              <a-tag >{{user.name}} ({{user.num}})</a-tag>
              <a-icon type="close-circle" @click="yundongyuanRemove(index)" />
            </div>
            <a @click="yundongyuanPickerShow = true" v-show="!yundongyuanPickerShow" href="#nogo">新增</a>
            <yundongyuan-picker style="width: 300px; margin-right: 10px;" :user_id="formData.user_id" :danwei_id="formData.danwei_id"   @onSelect="onYundongyuanAdd" v-show="yundongyuanPickerShow" />
            <a @click="yundongyuanPickerShow = false" v-show="yundongyuanPickerShow" href="#nogo">取消</a>
          </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">

              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="替补运动员"
                      hasFeedback
              >

                <div v-for="(user,index) in formData.tbydy" :key="index" >
                  <a-tag >{{user.name}} ({{user.num}})</a-tag>
                  <a-icon type="close-circle" @click="tbYundongyuanRemove(index)" />
                </div>
                <a @click="tbYundongyuanPickerShow = true" v-show="!tbYundongyuanPickerShow" href="#nogo">新增</a>
                <yundongyuan-picker style="width: 300px; margin-right: 10px;" :user_id="formData.user_id" :danwei_id="formData.danwei_id"  @onSelect="onTbYundongyuanAdd" v-show="tbYundongyuanPickerShow" />
                <a @click="tbYundongyuanPickerShow = false" v-show="tbYundongyuanPickerShow" href="#nogo">取消</a>
              </a-form-item>
              </a-col>
            </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">

          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="教练员"
                  hasFeedback
          >

            <div v-for="(user,index) in formData.jiaolian" :key="index" >
              <a-tag >{{user.name}} ({{user.num}})</a-tag>
              <a-icon type="close-circle" @click="jiaolianRemove(index)" />
            </div>
            <a @click="jiaolianPickerShow = true" v-show="!jiaolianPickerShow" href="#nogo">新增</a>
            <subject-jiaolian-picker style="width: 300px; margin-right: 10px;" :options="formData.jiaolian_options" @onSelect="onJiaolianAdd" v-show="jiaolianPickerShow" />
            <a @click="jiaolianPickerShow = false" v-show="jiaolianPickerShow" href="#nogo">取消</a>

          </a-form-item>
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="项目音乐"
                  hasFeedback
              >
<!--                附件上传-->
                <file-uploader
                    :numberLimit="1"
                    accept=".mp3,.mp4,.wma"
                    :file-list="formData.music"
                /> 
              </a-form-item>
              </a-col>
            <a-col :md="12" :sm="24">

              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="项目视频"
                  hasFeedback
              >
<!--                附件上传-->
                <file-uploader
                    :numberLimit="1"
                    accept=".mp4,.mov"
                    :file-list="formData.video"
                /> 
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">

              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="集赞截图"
                  hasFeedback
              >
<!--                附件上传-->
                <pic-uploader
                    :numberLimit="1"
                    accept=".jpg,.png"
                    :file-list="formData.jizan_pic"
                /> 
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">

              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="点赞数"
                hasFeedback
              >
                <a-input
                v-model="formData.jizan_count"
                  placeholder="请输入点赞数"
                />
              </a-form-item>
            </a-col>
            </a-row>

        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>

  </a-card>
  </template>

  <script>
  import STable from '@/components/table/'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import AInput from 'ant-design-vue/es/input/Input'
  import EditableCell from '@/components/EditableCell/'
  import PicUploader from '@/components/PicUploader/'
  import FileUploader from '@/components/FileUploader/'
  import YundongyuanPicker from '@/components/YundongyuanPicker/'
  import SubjectJiaolianPicker from '@/components/SubjectJiaolianPicker/'
  import setting from '@/config/setting'
  import moment from 'moment'
  import 'moment/locale/zh-cn';
  moment.locale('zh-cn');

  import { getApplySubjectList ,applySubjectDetail,editApplySubject,subjectOptions ,sjsqOptions,subjectDelete, subjectMusicList} from '@/api/sai'
  export default {
    name: 'KaojiApplySubjectList',
    components: {
      AInput,
      ATextarea,
      FileUploader,
      PicUploader,
      STable,
      EditableCell,
      YundongyuanPicker,
      SubjectJiaolianPicker,
    },
    data () {
      return {
        subjectOptions:[],
        sjsqOptions:[],
        visible: false,
        yundongyuanPickerShow: false,
        tbYundongyuanPickerShow: false,
        jiaolianPickerShow: false,
        saveLoading:false,
        musicKeywords: '',
        musicList: [],
        formData:{
          id:0,
          danwei:'',
          jizan_count:'',
          jiaolian:[],
          caipan:[],
          yundongyuan:[],
          tbydy:[],
          jizan_pic:[],
          music:[],
          pic:[],
          videos:[],
          video:[],
          subjects:[],
          subject_options:[],
          jiaolian_options:[],
        },
        time_range_moment:[],
        time_range:[],
        labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
          xs: { span: 24 },
          sm: { span: 8 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
        form: this.$form.createForm(this),
        mdl: {},

        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
          is_jizan:2,
          keywords:'',
          baoming_id: 0,
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '50px'
          },
          {
            title: '单位信息',
            dataIndex: 'danwei',
            scopedSlots: { customRender: 'danwei' },
          },
          {
            title: '赛区',
            dataIndex: 'saiqu',
            scopedSlots: { customRender: 'saiqu' },
          },
          {
            title: '状态',
            dataIndex: 'status',
            scopedSlots: { customRender: 'status' },
          },
          {
            title: '操作',
            dataIndex: 'action',
            fixed: 'right',
            width: 150,
            scopedSlots: { customRender: 'action' },
          }
        ],
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          console.log('loadData');
          console.log(this.queryParam);
          let that= this;

          if (this.time_range_moment[0] && this.time_range_moment[1]) {
            this.queryParam.time_range = [
              this.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),
              this.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')
            ]
          } else {
            this.queryParam.time_range = []
          }

          this.queryParam.baoming_id = this.$route.query.baoming_id
          console.log('this.$route.query.baoming_id', this.$route.query.baoming_id)
          this.queryParam = Object.assign(this.queryParam,parameter);
          return getApplySubjectList(this.queryParam)
            .then(res => {
              console.log('res');
              return res.data
            })
        },

        selectedRowKeys: [],
        selectedRows: [],
        cashFormData:{
          ids:[],
          to_type:'',
          price:0,
          note:'',
          count:0,
        }
      }
    },
    computed:{
    },
    created(){
    },

    mounted(){
      let that = this;
      that.queryParam.baoming_id = that.$route.query.baoming_id
      that.getSjsqOptions();
    },
    methods: {
      moment,
      getSjsqOptions(){
        let that = this;
        sjsqOptions({
          is_jizan:2
        }).then(res =>{
          that.sjsqOptions = res.data;
        });
      },
      subjectMusicSearch(value) {
        console.log('subjectMusicSelect', value);
        this.musicKeywords = value;
        this.getSubjectMusicList()
      },
      getSubjectMusicList() {
        subjectMusicList({keywords: this.musicKeywords})
            .then(res => {
              this.musicList = res.data.list
            })
      },

      onSjsqChange(value){
        let that = this;
        if(value.length ==2){
          console.log(value);
          that.getSubjectOptions(value[1]);
        }
      },
      handleCancel(){
        this.visible = false
      },
      //展开关闭
      toggleAdvanced() {
        this.advanced = !this.advanced
      },
      getSubjectOptions(saiqu){
        let that = this;
        console.log(saiqu);
        subjectOptions({
          saiqu:saiqu
        }).then(res =>{
          that.subjectOptions = res.data;
        });
      },
      yundongyuanRemove(index){
        console.log('yundongyuanRemove',index);
        this.formData.yundongyuan.splice(index,1);
        this.yundongyuanPickerShow = false;
      },
      onYundongyuanAdd(value){
        console.log('onYundongyuanAdd',value);
        let exist = this.formData.yundongyuan.filter(item =>{
          return item.num == value.num
        });
        if(exist.length >0){
          this.yundongyuanPickerShow = false;
          return ;
        }
        this.formData.yundongyuan.push(value);
        this.yundongyuanPickerShow = false;
      },
      tbYundongyuanRemove(index){
        this.formData.tbydy.splice(index,1)
        this.tbYundongyuanPickerShow = false;
      },
      onTbYundongyuanAdd(value){
        let exist = this.formData.tbydy.filter(item =>{
          return item.num == value.num
        });
        if(exist.length >0){
          this.tbYundongyuanPickerShow = false;
          return ;
        }
        this.formData.tbydy.push(value);
        this.tbYundongyuanPickerShow = false;
      },
      jiaolianRemove(index){
        this.formData.jiaolian.splice(index,1)
        this.jiaolianPickerShow = false;
      },
      onJiaolianAdd(value){
        let exist = this.formData.jiaolian.filter(item =>{
          return item.num == value.num
        });
        if(exist.length >0){
          this.jiaolianPickerShow = false;
          return ;
        }
        this.formData.jiaolian.push(value);
        this.jiaolianPickerShow = false;
      },
      handleEdit(record){
        let self = this
        this.visible = true
        applySubjectDetail({ id: record.id }).then(res => {
          setTimeout(() =>{
//            self.form.setFieldsValue({ ...res.data })
            self.formData.id = record.id;
            console.log('handleEdit')
            self.formData.yundongyuan =  [];
            // self.formData = JSON.parse(JSON.stringify(res.data)) ;
            let formData = JSON.parse(JSON.stringify(res.data));
            let subjectArr = formData.subject.split(".");
            self.formData.baoming_id = formData.baoming_id;
            self.formData.jiaolian = formData.jiaolian;
            self.formData.jiaolian_options = formData.jiaolian_options; 
            self.formData.tbydy = formData.tbydy;
            self.formData.video = formData.video;
            self.formData.jizan_count = formData.jizan_count;
            self.formData.jizan_pic = formData.jizan_pic;
            self.formData.yundongyuan = formData.yundongyuan;
            self.formData.subject = formData.subject;
            self.formData.music = formData.music;
            self.formData.subject_name = formData.subject_name;
            self.formData.subjects = [];
            self.formData.subject_options = formData.subject_options
            for(var i = 0 ; i< subjectArr.length ; i++){
              self.formData.subjects.push( [...subjectArr].splice(0, i+1).join('.'));
            }
            console.log('self.formData.subjects',self.formData.music);

            // if( self.formData.music.length > 0) {
            //   self.formData.music = self.formData.music[0].url
            // }
            //
            // if(res.data.music.length > 0) {
            //   self.musicKeywords = res.data.music[0].name
            // }
            // 根据音乐筛选搜索
            // self.getSubjectMusicList()
          },200)
        })
        // console.log(this.mdl)
      },
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false)
    },
    onFormSubjectChange(value,options){
      console.log(value,options);
      // this.formData.subjects = value;
      this.formData.subject = value[value.length-1]
      this.formData.subject_name = options.map(item =>{
        return item.name;
      }).join('-');
      console.log(this.formData.subject,this.formData.subject_name);
    },

      // 增改 处理
      handleOk(e) {
        let self = this;
        e.preventDefault()
        this.form.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
            console.log('Received valuess of formData: ', self.formData)


            self.saveLoading = true;
            editApplySubject({
              id:self.formData.id,
              baoming_id:self.formData.baoming_id,
              subject_name:self.formData.subject_name,
              music:JSON.stringify(self.formData.music),
              subject:self.formData.subject,
              yundongyuan:JSON.stringify(self.formData.yundongyuan),
              jiaolian:JSON.stringify(self.formData.jiaolian),
              tbydy:JSON.stringify(self.formData.tbydy),
              video:JSON.stringify(self.formData.video),
              jizan_pic:JSON.stringify(self.formData.jizan_pic),
              jizan_count:(self.formData.jizan_count),
            }).then(res => {
              self.$message.success('修改成功')
              self.$refs.table.refresh(false)
              self.visible = false;
              self.saveLoading = false;
            }).catch(err =>{
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          }
        })
      },

      download(){
        getDownloadUrl(this.queryParam).then(res =>{
          console.log(res);
          window.open(res.data);
        })
      },
    onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },


      // 删
      onDelete(record) {
        let self = this
        subjectDelete({
          subject_id: record.id,
            baoming_id:record.baoming_id
        } ).then(res => {
          self.$message.success('删除成功')
          self.$refs.table.refresh()
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })
      },


      download(type){
        console.log('this.queryParam')
        console.log(this.queryParam)
        if(typeof this.queryParam.sjsq == 'undefined' || this.queryParam.sjsq.length !=2){
          this.$message.error('请先选择赛区');
          return ;
        }
        switch (type){
          case 1:
            window.open(setting.apiBaseURL+'/adminapi/sai/csxmhzDownload?saiqu='+this.queryParam.sjsq[1]);
            break;
          case 2:
            window.open(setting.apiBaseURL+'/adminapi/sai/xmhzbDownload?saiqu='+this.queryParam.sjsq[1]);
            break;
          case 3:
            window.open(setting.apiBaseURL+'/adminapi/sai/ydycsxmDownload?saiqu='+this.queryParam.sjsq[1]);
            break;

        }
      },

    sjsqFilter(inputValue, path) {
      return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
    },

    },
    filters:{
    },
    watch: {
    }
  }
</script>
